import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
// import SelectFirm from "../SelectFirm/SelectFirm";
import OpenInCrmButton from "../OpenInCrmButton/OpenInCrmButton";
import FirmPeople from "./FirmPeople";

const FirmInfo = ({data, handleChangeInput, viewMode, deleted, handleChangeDropdown, people, peopleBusy, peopleError}) => {
    const hasCrmId = Boolean(data && data.CRM_ID);

    return (
        <React.Fragment>
        <div className="Firm-info">
            <div className="Firm-info_column">
                <Input
                    className="Firm-info_column_item"
                    required
                    valueType="text"
                    name="NAME"
                    label="NAME"
                    value={data.NAME}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="ADDRESS"
                    label="ADDRESS"
                    value={data.ADDRESS}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="CITY"
                    label="CITY"
                    value={data.CITY}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Firm-info_column_item"
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.STATE}
                    valueKey="STATE"
                    label="State"
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            </div>
            <div className="Firm-info_column">
                <Input
                    className="Firm-info_column_item"
                    valueType="text"
                    name="ZIP"
                    label="ZIP"
                    value={data.ZIP}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Firm-info_column_item"
                    valueType="phone"
                    name="PHONE"
                    label="PHONE"
                    value={data.PHONE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {/* <SelectFirm
                    className="Firm-info_column_item"
                    value={data.PARENT_FIRM}
                    firmName={data.NAME}
                    valueKey="PARENT_FIRM"
                    label="PARENT FIRM"
                    data={data}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                /> */}
                <Input className="Firm-info_column_item"
                       valueType='text'
                       name='WEBSITE'
                       label='Website'
                       value={data.WEBSITE}
                       handleParentChange={handleChangeInput}
                       viewMode={viewMode}
                       deleted={deleted}
                />
                {/*
                    Shown, never typed. CRM_ID is the link to the organization
                    this firm's edits are pushed to, so editing it here would
                    quietly repoint the firm -- and the next organization
                    webhook would overwrite it with that other firm's details.
                */}
                <Input className="Firm-info_column_item"
                       valueType='text'
                       name='CRM_ID'
                       label='CRM ID'
                       value={data.CRM_ID}
                       viewMode={true}
                       deleted={deleted}
                />
                {hasCrmId && (
                    <div style={{
                        marginTop: '12px',
                        padding: '12px 16px',
                        backgroundColor: '#e8f5e9',
                        borderRadius: '8px',
                        border: '1px solid #c8e6c9'
                    }}>
                        <OpenInCrmButton
                            leadId={data.CRM_ID}
                            entityType="organization"
                            variant="button"
                        />
                    </div>
                )}
            </div>
        </div>
        {data && data.ARCIMEDES_ROW_ID && (
            <FirmPeople people={people} isBusy={peopleBusy} error={peopleError}/>
        )}
        </React.Fragment>
    );
};

export default FirmInfo;
